import {asyncRequest} from "./Requests";

const createUserRequest = async (request_data) => {
    const response = await asyncRequest('post', '/add_user', request_data);
    return response.response;
}

export default createUserRequest;